import { Head, Link } from '@inertiajs/react'
import type { Keg } from '@/types'

type Labels = {
  heading: string
  description: string
  download_button: string
  view_all_link: string
}

type Props = {
  kegs: Keg[]
  labels: Labels
}

export default function KegsCreated({ kegs, labels }: Props) {
  const qrCodesHref = `/kegs/qr_codes?${kegs.map((keg) => `identifiers[]=${keg.identifier}`).join('&')}`

  return (
    <>
      <Head title={labels.heading} />
      <div className="mx-auto max-w-2xl px-4 py-16 text-center sm:px-6 lg:px-8">
        <span className="mx-auto flex h-16 w-16 animate-fade-in items-center justify-center rounded-2xl bg-leaf text-paper">
          <svg viewBox="0 0 24 24" className="h-8 w-8" fill="none" stroke="currentColor" strokeWidth={2.5}>
            <path d="M5 12.5l4.5 4.5L19 7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>

        <h1 className="mt-6 animate-fade-in-up font-display text-4xl text-ink">{labels.heading}</h1>
        <p className="mx-auto mt-3 max-w-md animate-fade-in-up animation-delay-100 text-ink-soft">{labels.description}</p>

        <ul className="mt-6 flex animate-fade-in-up animation-delay-100 flex-wrap justify-center gap-2">
          {kegs.map((keg) => (
            <li
              key={keg.identifier}
              className="rounded-full border border-line bg-card px-3 py-1 text-sm font-bold text-ink"
            >
              {keg.identifier}
            </li>
          ))}
        </ul>

        <div className="mt-8 flex animate-fade-in-up animation-delay-200 flex-col items-center gap-3">
          <a
            href={qrCodesHref}
            className="inline-flex items-center justify-center gap-2 rounded-xl border-2 border-ink bg-flame px-5 py-3 text-sm font-bold text-paper shadow-hard transition-transform hover:-translate-y-0.5 motion-reduce:transform-none"
          >
            {labels.download_button}
          </a>
          <Link href="/kegs" className="text-sm font-semibold text-ink-soft hover:text-ink">
            {labels.view_all_link}
          </Link>
        </div>
      </div>
    </>
  )
}
